import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { formatBreadcrumb } from "src/utils/string-utils";
import NavbarMenu from "./menu";
import Button from "../button";

function Navbar() {
    const location = useLocation();
    
    // State to handle sidebar open/close on mobile
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    // Helper to close the sidebar when a link is clicked
    const handleLinkClick = () => {
        scrollToTop();
        setIsSidebarOpen(false);
    };

    return (
        <>
            <div className="w-full fixed z-50 bg-white">
                <div className="flex flex-row justify-between items-center px-[24px] py-[16px] border-b-[1px]">    
                    <Link onClick={scrollToTop} to="/">
                        <img src={'/icons/hmt-logo.svg'} alt="HMT Logo" />
                    </Link>
                    
                    {/* Desktop Menu */}
                    <ul className="flex flex-row gap-[8px] text-[16px] font-normal tracking-normal justify-center items-center lg:flex hidden">
                        <NavbarMenu onClick={scrollToTop} menu_id={1}></NavbarMenu>
                        <NavbarMenu onClick={() => {}} menu_id={2}></NavbarMenu>
                        <NavbarMenu onClick={scrollToTop} menu_id={3}></NavbarMenu>
                        <NavbarMenu onClick={scrollToTop} menu_id={4}></NavbarMenu>
                        <Button color="black" onClick={() => {}} to={"/contact-us"}>Contact Us</Button>
                    </ul>

                    {/* Mobile Hamburger Button */}
                    <button 
                        className="lg:hidden flex items-center justify-center p-2 text-black"
                        onClick={() => setIsSidebarOpen(true)}
                        aria-label="Open Menu"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
                
                {/* Breadcrumbs */}
                <div className={`${location.pathname === '/' ? "hidden" : "lg:flex hidden"} py-[16px] px-[24px] border-b-[1px] text-[14px] text-grey`}>
                    {formatBreadcrumb(location.pathname)}
                </div>
            </div>

            {/* --- Mobile Sidebar Overlay --- */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-[60] lg:hidden transition-opacity"
                    onClick={() => setIsSidebarOpen(false)}
                ></div>
            )}

            {/* --- Mobile Sidebar Panel --- */}
            <div className={`fixed top-0 right-0 h-full w-[280px] bg-white z-[70] transform transition-transform duration-300 ease-in-out lg:hidden ${
                isSidebarOpen ? "translate-x-0" : "translate-x-full"
            }`}>
                {/* Close Button */}
                <div className="flex justify-end p-6 border-b-[1px]">
                    <button onClick={() => setIsSidebarOpen(false)} aria-label="Close Menu">
                        <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Mobile Links */}
                <ul className="flex flex-col gap-6 p-6 text-[16px] font-normal tracking-normal">
                    <NavbarMenu onClick={handleLinkClick} menu_id={1} isMobile={true}></NavbarMenu>
                    <NavbarMenu onClick={() => { setIsSidebarOpen(false); }} menu_id={2} isMobile={true}></NavbarMenu>
                    <NavbarMenu onClick={handleLinkClick} menu_id={3} isMobile={true}></NavbarMenu>
                    <NavbarMenu onClick={handleLinkClick} menu_id={4} isMobile={true}></NavbarMenu>
                    <div className="mt-4">
                        <Button color="black" onClick={() => setIsSidebarOpen(false)} to={"/contact-us"}>Contact Us</Button>
                    </div>
                </ul>
            </div>
        </>
    );
}

export default Navbar;